import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../i18n/en.json';
import ptBr from '../i18n/pt-br.json';

export type Lang = 'en' | 'pt-br';

const LANG_KEY = 'tpe.lang';

function initialLang(): Lang {
  const stored = localStorage.getItem(LANG_KEY) as Lang | null;
  if (stored === 'en' || stored === 'pt-br') return stored;
  const nav = (navigator.language || 'en').toLowerCase();
  return nav.startsWith('pt') ? 'pt-br' : 'en';
}

export const i18nReady = i18next.use(LanguageDetector).init({
  resources: {
    en: { translation: en },
    'pt-br': { translation: ptBr },
  },
  lng: initialLang(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  detection: {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: LANG_KEY,
    caches: ['localStorage'],
  },
});

export function setLang(lang: Lang): void {
  i18next.changeLanguage(lang);
  localStorage.setItem(LANG_KEY, lang);
  document.documentElement.lang = lang === 'pt-br' ? 'pt-BR' : 'en';
  window.dispatchEvent(new CustomEvent('tpe:lang-change', { detail: lang }));
}

export function currentLang(): Lang {
  return (i18next.language as Lang) || 'en';
}

export function t(key: string): string {
  return i18next.t(key);
}
